import { http } from './_http';
import { logWebHrError } from '@/core/logger/log-wrapper';

/**
 * @return {Promise<AxiosResponse<any>>}
 */
export default async function getForms(tenantId, onboardingId) {
  try {
    const { data } = await http.get(
      `/tenants/${tenantId}/onboardings/${onboardingId}/form-templates`
    );

    return data.data;
  } catch (e) {
    logWebHrError({
      message: 'Failed to get forms',
      source: 'get-forms',
      metadata: {
        tenantId,
        onboardingId,
      },
      error: e,
    });
    throw e;
  }
}
